import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { META_KEYS, MetaKey } from '../database/offlineDatabase/types/offlineDatabaseMeta.types';
import { waitOfflineEncryptionKey } from '../utils/waitOfflineEncryptionKey.util';

export const offlineMetaRepository = {
  getByKey: async (key: MetaKey) => {
    await waitOfflineEncryptionKey();
    const data = await offlineDatabase.meta.toArray();
    return data.find((meta) => meta.key === key);
  },

  save: async (key: MetaKey, value: boolean) => {
    return offlineDatabase.meta.put({ key, value });
  },

  updateCanEnterInOfflineMode: async (value: boolean) => {
    const meta = await offlineMetaRepository.getByKey(META_KEYS.canEnterInOfflineMode);

    if (meta?.value !== value) {
      await offlineMetaRepository.save(META_KEYS.canEnterInOfflineMode, value);
    }
  },
};
